import React, { useState } from 'react';

import { useTransition, animated, config } from 'react-spring'
import { Menu, Header } from 'semantic-ui-react'
import { HashLink } from 'react-router-hash-link';

import DataExtractionImg from '../../../resources/features/DataExtraction.png'
import DataQualityControlImg from '../../../resources/features/DataQualityControl.png'
import DataSelfServiceImg from '../../../resources/features/DataSelfService.png'
import ComplexChartsImg from '../../../resources/features/ComplexCharts.png'
import TrackingBenchmarkingImg from '../../../resources/features/TrackingBenchmarking.png'
import AIDrivenImg from '../../../resources/features/AI-Driven.png'
import AutomatekeyImg from '../../../resources/features/Automatekey.png'
import AutomatedAlertsImg from '../../../resources/features/AutomatedAlerts.png'
import NativeChatImg from '../../../resources/features/NativeChat.png'
import IntegrationImg from '../../../resources/features/Integration.png'

import './SectionOne.scss';


const SectionOne = () => {

	const [activeItem, setactiveItem] = useState('DataSensing');

	const routeChange = (path) => {
		setactiveItem(path);
	};

	

	return (
		<React.Fragment>
			<div className='FeaturesSectionOne'>
				<div className='FeaturesSectionOne-head'>
					<h1 className='FeaturesSectionOne-header'>
						Enterprise Capabilities, Connected in One Platform
					</h1>
					<p className='FeaturesSectionOne-sub'>
						EPMTech brings together enterprise data, AI intelligence, decision optimization, business applications <br/>and execution capabilities to support continuous enterprise performance management.
					</p>
				</div>
			</div>

			<div className="FeaturesSectionOne-Menu">
		        <Menu pointing secondary>
		            <Menu.Item
		              name='DataSensing'
		              active={
							activeItem === 'DataSensing' 
					  }
					  onClick={() => routeChange('DataSensing')}
		            >
		              <Header as='h4'>Data & Sensing</Header>
		            </Menu.Item>
		             <Menu.Item
		              name='DecisionIntelligence'
		              active={
							activeItem === 'DecisionIntelligence' 
					  }
					  onClick={() => routeChange('DecisionIntelligence')}
		            >
		              <Header as='h4'>Decision Intelligence & Optimization</Header>
		            </Menu.Item>
		             <Menu.Item
		              name='ApplicationsExecution'
		              active={
							activeItem === 'ApplicationsExecution' 
					  }
					  onClick={() => routeChange('ApplicationsExecution')}
		            >
		              <Header as='h4'>Applications & Execution</Header>
		            </Menu.Item>
		        </Menu>
	    	</div>

			{
				activeItem == "DataSensing" && 
				<div className="DataSensing-content-wrapper content-wrapper">
	     			<h1 className='DataSensing-content-header header'>
						Data & Sensing
					</h1>
	        		<div id="DataExtraction" className="section-custom DataExtraction">
			            <div className="content-wrapper-left">
			            	<div className="header1">CONNECT & CONTEXTUALIZE</div>
			            	<div className="header2">Bring Enterprise Data Together in One Connected Layer</div>
			            	<div className="txt-content">
				                <p>The EPMTech Platform enables you to:</p>
				                <ul>
				                  <li><span>Data integration and harmonization</span></li>
				                  <li><span>Master data management</span></li>
				                  <li><span>Data quality</span></li>
				                  <li><span>Semantic layer</span></li>
								  <li><span>Ontology and knowledge graph</span></li>
								  <li><span>Data security and lineage</span></li>
				                </ul>
			             	</div>
			            </div>
			            <div className="content-wrapper-right">
			            	<img src={DataExtractionImg} className="img-content img-DataExtraction"  alt="img-content"/>
			            </div>
	        		</div>

	        		<div id="DataQualityControl" className="section-custom-2 DataQualityControl">
			            <div className="content-wrapper-left">
			            	<img src={DataQualityControlImg} className="img-content img-DataQualityControl"  alt="img-content"/>
			            </div>
			            <div className="content-wrapper-right">
			             	<div className="header1">UNDERSTAND & PREDICT</div>
			            	<div className="header2">Turn Enterprise Data into Actionable Intelligence</div>
			            	<div className="txt-content">
				                <p>The EPMTech Platform ensures:</p>
								<ul>
									<li><span>KPI intelligence</span></li>
									<li><span>Anomaly detection</span></li>
									<li><span>Root-cause AI</span></li>
									<li><span>AskEPM and GenAI</span></li>
									<li><span>Forecasting</span></li>
									<li><span>External signals</span></li>
									<li><span>Risk and opportunity sensing</span></li>
								</ul>
			             	</div>
			            </div>
	        		</div>

	        		<div id="DataSelfService" className="section-custom DataSelfService">
			            <div className="content-wrapper-left">
			            	<div className="header1">DATA SELF-SERVICE & ANALYTICS STUDIO</div>
			            	<div className="header2">Make Enterprise Data Accessible to Every User</div>
			            	<div className="txt-content">
				                <p>The EPMTech Platform provides:</p>
								<ul>
									<li><span>A single source of truth for business and technical users</span></li>
									<li><span>User-friendly access to enterprise data without technical barriers</span></li>
									<li><span>The ability to combine and process large volumes of data from different sources</span></li>
									<li><span>Drag-and-drop report generation and analysis with minimal IT intervention</span></li>
								</ul>
			             	</div>
			            </div>
			            <div className="content-wrapper-right">
			            	<img src={DataSelfServiceImg} className="img-content img-DataSelfService"  alt="img-content"/>
			            </div>
	        		</div>
        		</div>
			}

			{
				activeItem == "DecisionIntelligence" && 
				<div className="DecisionIntelligence-content-wrapper content-wrapper">
	     			<h1 className='DecisionIntelligence-content-header header'>
						Decision Intelligence & Optimization
					</h1>
	        		<div id="ComplexCharts" className="section-custom ComplexCharts">
			            <div className="content-wrapper-left">
			            	<div className="header1">PLANNING, SIMULATION & OPTIMIZATION</div>
			            	<div className="header2">Evaluate Scenarios. <br/>Make Better Business Decisions.</div>
			            	<div className="txt-content">
				                <p>The EPMTech Platform enables:</p>
				                <ul>
				                  <li><span>Connected planning and xP&A</span></li>
				                  <li><span>Scenario simulation</span></li>
				                  <li><span>S&OP / IBP</span></li>
				                  <li><span>Constraint models</span></li>
				                  <li><span>Prescriptive AI</span></li>
				                  <li><span>Multi-objective optimization</span></li>
				                  <li><span>Economic impact analysis</span></li>
								</ul>
			             	</div>
			            </div>
			            <div className="content-wrapper-right">
			            	<img src={ComplexChartsImg} className="img-content img-ComplexCharts"  alt="img-content"/>
			            </div>
	        		</div>

	        		<div id="TrackingBenchmarking" className="section-custom-2 TrackingBenchmarking">
			            <div className="content-wrapper-left">
			            	<img src={TrackingBenchmarkingImg} className="img-content img-TrackingBenchmarking"  alt="img-content"/>
			            </div>
			            <div className="content-wrapper-right">
			             	<div className="header1">PERFORMANCE TRACKING & BENCHMARKING</div>
			            	<div className="header2">Raise levels of performance to best-in-class</div>
			            	<div className="txt-content">
				                <p>The EPMTech Platform enables:</p>
				                <ul>
				                  <li><span>Continuous benchmarking against internal and external criteria</span></li>
				                  <li><span>Performance monitoring and updates</span></li>
				                  <li><span>Variance analysis</span></li>
				                  <li><span>Geospatial analytics</span></li>
				                  <li><span>Identification of performance gaps and improvement opportunities</span></li>
				                </ul>
			             	</div>
			            </div>
	        		</div>

	        		<div id="AI-Driven" className="section-custom AI-Driven">
			            <div className="content-wrapper-left">
			            	<div className="header1">AI-Driven Business Models</div>
			            	<div className="header2">Generate Accurate Forecasts to Drive Business Planning</div>
			            	<div className="txt-content">
				                <p>The EPMTech Platform provides the capability to:</p>
				                <ul>
				                  <li><span>Leverage data and AI to improve planning cycles</span></li>
				                  <li><span>Apply optimization, scheduling and forecasting at granular levels</span></li>
				                  <li><span>Conduct clustering and segmentation</span></li>
				                  <li><span>Run simulations and predictive analytics</span></li>
				                  <li><span>Evaluate business scenarios and trade-offs</span></li>
				                </ul>
			             	</div>
			            </div>
			            <div className="content-wrapper-right">
			            	<img src={AIDrivenImg} className="img-content img-AI-Driven"  alt="img-content"/>
			            </div>
	        		</div>
	        	</div>
			}

	     	{
	     		activeItem == "ApplicationsExecution" && 
	     		<div className="ApplicationsExecution-content-wrapper content-wrapper">
	     			<h1 className='ApplicationsExecution-content-header header'>
						Applications & Execution
					</h1>
	        		<div id="Automatekey" className="section-custom Automatekey">
			            <div className="content-wrapper-left">
			            	<div className="header1">Automate key processes and initiatives</div>
			            	<div className="header2">Automate income statement, working capital and asset management processes</div>
			            	<div className="txt-content">
				                <p>The EACIIT Platform’s automation capabilities enable better:</p>
				                <ul>
				                  <li><span>Planning, forecasting & reporting</span></li>
				                  <li><span>Balancing supply chain and resources</span></li>
				                  <li><span>Manage projects and initiatives</span></li>
				                </ul>
			             	</div>
			            </div>
			            <div className="content-wrapper-right">
			            	<img src={AutomatekeyImg} className="img-content img-Automatekey"  alt="img-content"/>
			            </div>
	        		</div>

	        		<div id="AutomatedAlerts" className="section-custom-2 AutomatedAlerts">
			            <div className="content-wrapper-left">
			            	<img src={AutomatedAlertsImg} className="img-content img-AutomatedAlerts"  alt="img-content"/>
			            </div>
			            <div className="content-wrapper-right">
			             	<div className="header1">Automated alerts, reports and insights </div>
			            	<div className="header2">Reduce or eliminate human monitoring & intervention</div>
			            	<div className="txt-content">
				                <p>The EACIIT Platform automation capabilities enable:</p>
				                <ul>
				                  <li><span>Proactive management of financial, performance and operational issues</span></li>
				                  <li><span>Early warning triggers and remedial action</span></li>
				                  <li><span>Push notifications across devices</span></li>
				                </ul>
			             	</div>
			            </div>
	        		</div>

	        		<div id="NativeChat" className="section-custom NativeChat">
			            <div className="content-wrapper-left">
			            	<div className="header1">Native chat & email</div>
			            	<div className="header2">Seamless user communication</div>
			            	<div className="txt-content">
				                <p>The EACIIT Platform provides:</p>
				                <ul>
				                  <li><span>Embedded IM functionality tagged to issues & initiatives </span></li>
				                  <li><span>Automated email functionality to escalate & distribute reports</span></li>
				                </ul>
			             	</div>
			            </div>
			            <div className="content-wrapper-right">
			            	<img src={NativeChatImg} className="img-content img-NativeChat"  alt="img-content"/>
			            </div>
	        		</div>

	        		<div id="Integration" className="section-custom-2 Integration">
			            <div className="content-wrapper-left">
			            	<img src={IntegrationImg} className="img-content img-Integration"  alt="img-content"/>
			            </div>
			            <div className="content-wrapper-right">
			            	<div className="header1">Integration</div>
			            	<div className="header2">Seamless integration with other systems in the organization</div>
			            	<div className="txt-content">
				                <p>The EACIIT Platform equips you:</p>
				                <ul>
				                  <li><span>With open-source API’s to combine with ERP and other software</span></li>
				                  <li><span>To execute new business models with agility & no technical roadblocks</span></li>
				                </ul>
			             	</div>
			            </div>
	        		</div>
	        	</div>
	     	}

        	

        	

		</React.Fragment>
)}

export default SectionOne;